module.exports = __webpack_public_path__ + "c95bf10b355dc932ebefdd1375c55e16.png";